import { render, staticRenderFns } from "./DigitalOrderDeliverySelection.vue?vue&type=template&id=16a7d044"
import script from "./DigitalOrderDeliverySelection.vue?vue&type=script&lang=js"
export * from "./DigitalOrderDeliverySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports